import {Component, OnDestroy, OnInit} from '@angular/core';
import {ListItemsComponent} from '@abstract/list-items/list-items.component';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html'
})
export class LayoutComponent implements OnInit, OnDestroy {

    public currentMountedComponent: ListItemsComponent;

    constructor() {}

    ngOnInit() {

    }

    ngOnDestroy(): void {

    }

    onActivate(component: ListItemsComponent) {
        this.currentMountedComponent = component;
    }
}
